module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iJgQD"))).then(() => parcelRequire('5erN3'));